import Vue from 'vue'
import Api from './api'
import config from './../config'

Vue.use(Api, config)

export default new Api()